import { render, staticRenderFns } from "./MyShareCode.vue?vue&type=template&id=3f45448f&scoped=true&"
import script from "./MyShareCode.vue?vue&type=script&lang=js&"
export * from "./MyShareCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f45448f",
  null
  
)

export default component.exports